/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetDocumentViewHistoriesResponseData,
  GetDocumentViewHistoriesResponseDataFromJSON,
  GetDocumentViewHistoriesResponseDataFromJSONTyped,
  GetDocumentViewHistoriesResponseDataToJSON
} from './GetDocumentViewHistoriesResponseData'

/**
 *
 * @export
 * @interface GetSiteViewHistoriesResponse
 */
export interface GetSiteViewHistoriesResponse {
  /**
   *
   * @type {number}
   * @memberof GetSiteViewHistoriesResponse
   */
  status?: number
  /**
   *
   * @type {GetDocumentViewHistoriesResponseData}
   * @memberof GetSiteViewHistoriesResponse
   */
  data?: GetDocumentViewHistoriesResponseData
}

export function GetSiteViewHistoriesResponseFromJSON(json: any): GetSiteViewHistoriesResponse {
  return GetSiteViewHistoriesResponseFromJSONTyped(json, false)
}

export function GetSiteViewHistoriesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSiteViewHistoriesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetDocumentViewHistoriesResponseDataFromJSON(json['data'])
  }
}

export function GetSiteViewHistoriesResponseToJSON(value?: GetSiteViewHistoriesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetDocumentViewHistoriesResponseDataToJSON(value.data)
  }
}
